module.exports = __webpack_public_path__ + "img/onlylead01.d0b5ac37.jpg";